
    import '/Users/jilin/projects/antd/rc-dialog/docs/demo/ant-design.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-ant-design-demo-ant-design"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/jilin/projects/antd/rc-dialog/docs/demo/ant-design.md?type=demo')
};